import NetworkError from "../../components/NetworkError";
import Preloader from "../../components/Preloader";
import { confirmAlert } from "react-confirm-alert";
import 'react-confirm-alert/src/react-confirm-alert.css';
import Select from "react-select";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useContext, useState } from "react";
import { config } from "../../constants/config";
import { useEffect } from "react";
import { Asterisk, Calendar, TextLeft, TextParagraph } from "react-bootstrap-icons";
import UserContext from "../../contexts/UserContext";
import { textes } from "../../constants/textes";



export default function ProfilInfos({codeprofil}) {
    // states
    const {user, logoutUser} = useContext(UserContext);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [fetching, setFetching] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [editedstate, setEditedstate] = useState(false);
    const [error, setError] = useState(false);

    const [lib, setLib] = useState("");
    const [ident, setIdent] = useState("");
    const [desc, setDesc] = useState("");
    const [libespace, setLibespace] = useState("");
    const [descespace, setDescespace] = useState("");
    const [etat, setEtat] = useState("");
    const [datecrea, setDatecrea] = useState("");
    // const [dateupda, setDateupda] = useState("");
    const [space, setSpace] = useState("");
    const [spaces, setSpaces] = useState([]);
    const [edit, setedit] = useState(true);
    const [defaut, setdefaut] = useState(false);


    const showErrorMessage = (msg) => {
        toast.error(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }

    const showSuccesMessage = (msg) => {
        toast.success(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }

    const getListSpaces = async () => {
        // setLoading(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.secure.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/workspaces`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let clientarray = [];

                        clientarray = data?.body?.data;

                        let clientarraydata = [];
                        await clientarray.forEach(element => {
                            clientarraydata.push({label: element.lib, value: element.code});
                        });

                        let clientarraydata2 = [];
                        await clientarray.forEach(element => {
                            if (!element.defaut) {
                                clientarraydata2.push({label: element.lib, value: element.code});
                            }
                        });

                        if (user?.isFullAction) {
                            setSpaces(clientarraydata);
                        } else {
                            setSpaces(clientarraydata2)
                        }
                    } else {
                        if (data?.body?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            // setLoading(false);
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                // console.log("data error: fail");
            }
        }).catch((err) => {
            // console.log("cash error: ", err);;
        });
    }

    const getProfil = async () => {
        setLoading(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.secure.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/profiles/${codeprofil}`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let body = data?.body?.data[0];

                        setLib(body?.lib !== null ? body?.lib : "");
                        setIdent(body?.ident !== null ? body?.ident : "");
                        setDesc(body?.descr !== null ? body?.descr : "");
                        setLibespace(body?.libespacetravail ? body?.libespacetravail : "");
                        setDescespace(body?.descrespacetravail, body?.descrespacetravail);
                        setEtat(body?.etat !== null ? body?.etat : "");
                        setDatecrea(body?.datecrea !== null ? body?.datecrea.slice(0, 10) : "");
                        // setDateupda(body?.dateupda !== null ? body?.dateupda.slice(0, 10) : "");
                        setSpace(body?.codeespacetravail !== null ? {label: body?.libespacetravail, value: body?.codeespacetravail} : "");

                        setLoading(false);
                    } else {
                        if (data?.body?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            setError(true);
                            setLoading(false);
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                setError(true);
                setLoading(false);
            }
            
        }).catch((err) => {
            // console.log("error", err);
            setError(true);
            setLoading(false);
        });
    }

    const handleedit = () => {
        setedit(!edit);
    };

    const handledefaut = () => {
        setdefaut(!defaut);
    };


    // comportements
    useEffect(() => {
        getListSpaces();
        getProfil();
    }, []);


    const handleDelete = async () => {
        confirmAlert({
            title: 'Delete?',
            message: 'Are you sure you want to delete this profile?',
            buttons: [
                {
                    label: "Confirm",
                    style: {
                        backgroundColor: '#01203f',
                        color: "#ffffff"
                    },
                    onClick: async () => {

                        setFetching(true);

                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
                        myHeaders.append("token", config.secure.PUBLICKEY);
                        myHeaders.append("apikey", user.token);
                        myHeaders.append("cpte", user.code);
                        myHeaders.append("prof", user.profil);
                        myHeaders.append("conn", user.espace);

                        var requestOptions = {
                            method: 'DELETE',
                            headers: myHeaders,
                            // body: urlencoded,
                            redirect: 'follow'
                        };


                        // console.log("data send", urlencoded);

                        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/profiles/${codeprofil}`, requestOptions).then((response) => {
                            if (response?.status === 205) {
                                setFetching(false);
                                showSuccesMessage("Profile deleted successfully.");
                                setEditedstate(false);
                                navigate(-1);
                            } else if (response?.status === 200) {
                                response.json().then(async (data) => {
                                    // console.log("resonse delete droit", data);
                                    if (data?.body?.data?.msg === "expiredsession") {
                                        logoutUser();
                                        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                                    } else {
                                        setDeleting(false);
                                        showErrorMessage(data?.body?.data?.msg);
                                    }

                                });
                            } else if (response?.status === 401) {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // setError(true);
                                showErrorMessage("Service indisponible! Veuillez reassayer plutard.");
                                setDeleting(false);
                            }
                            
                        }).catch((err) => {
                            // console.log("error", err);
                            // setError(true);
                            showErrorMessage(config.texts.unavailblemsg);
                            setFetching(false);
                        });
                    }
                }, 
                {
                    label: "Cancel",
                    style: {
                        backgroundColor: '#ff0000',
                        color: "#ffffff"
                    },
                    onClick: async () => {
                        // console.log("cancel");
                    }
                }
            ],
            closeOnClickOutside: false
        })
    }

    const handleSubmitEdit = async (e) => {
        e.preventDefault();

        confirmAlert({
            title: 'Update?',
            message: 'Are you sure you want to update this profiles informations?',
            buttons: [
                {
                    label: "Confirm",
                    style: {
                        backgroundColor: '#01203f',
                        color: "#ffffff"
                    },
                    onClick: async () => {

                        setFetching(true);
                        
                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
                        myHeaders.append("token", config.secure.PUBLICKEY);
                        myHeaders.append("apikey", user.token);
                        myHeaders.append("cpte", user.code);
                        myHeaders.append("prof", user.profil);
                        myHeaders.append("conn", user.espace);

                        var urlencoded = new URLSearchParams();

                        urlencoded.append("lib", lib);
                        urlencoded.append("ident", ident);
                        urlencoded.append("descr", desc);
                        urlencoded.append("codeespacetravail", space["value"]);
                        urlencoded.append("defaut", defaut);
                        urlencoded.append("edit", edit);

                        var requestOptions = {
                            method: 'PUT',
                            headers: myHeaders,
                            body: urlencoded,
                            redirect: 'follow'
                        };

                        // console.log("data send", urlencoded)

                        await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/profiles/${codeprofil}`, requestOptions).then((response) => {
                            if (response?.status === 204) {
                                showSuccesMessage("Profile updated successfully.");
                                setEditedstate(false);
                                getProfil();
                                setFetching(false);

                            } else if (response?.status === 200) {
                                response.json().then(async (data) => {
                                    // console.log("resonse update rule", data);
                                    // let body = data?.body;

                                    if (data?.body?.data?.msg === "expiredsession") {
                                        logoutUser();
                                        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                                    } else {
                                        setFetching(false);
                                        showErrorMessage(data?.body?.data?.msg)
                                    }

                                });
                            } else if (response?.status === 401) {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // setError(true);
                                showErrorMessage("Service indisponible! Veuillez reassayer plutard.");
                                setFetching(false);
                            }
                            
                        })
                        .catch((err) => {
                            // console.log("error", err);
                            // setError(true);
                            showErrorMessage(config.texts.unavailblemsg);
                            setFetching(false);
                        });
                    }
                }, 
                {
                    label: "Cancel",
                    style: {
                        backgroundColor: '#ff0000',
                        color: "#ffffff"
                    },
                    onClick: async () => {
                        // console.log("cancel");
                    }
                }
            ],
            closeOnClickOutside: false
        })
    }



    // affichages
    return (
        <>
            {loading && <Preloader />}
            {!loading && error && <NetworkError />}
            {!loading && !error && <div className="row"> 
                <div className="col-md-12 mb-3">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card shadow mb-4">
                                <div className="card-header py-3">
                                    <button onClick={() => navigate(-1)} data-toggle="tooltip" title="Quit" data-placement="left" className="btn-shadow ml-3 btn btn-dark btn-sm float-right">
                                        <i className="fa fa-reply"></i> <span>Go Back</span>
                                    </button>
                                    {!editedstate && <button onClick={() => setEditedstate(true)}
                                        title="Update profile" 
                                        className="btn-shadow ml-3 btn btn-success btn-sm float-right">
                                        <i className="fa fa-edit mr-1"></i> <span>Update</span>
                                    </button>}
                                    {!editedstate && <button onClick={handleDelete}
                                        title="Delete profile" 
                                        className="btn-shadow ml-3 btn btn-danger btn-sm float-right">
                                        <i className="fa fa-trash mr-1"></i> <span>Delete</span>  {deleting && <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                        />}
                                    </button>}
                                    <h6 className="m-0 ">Informations du profil</h6>
                                </div>
                                <div className="card-body">
                                    <form style={{width: "100%"}} onSubmit={handleSubmitEdit}>
                                        <div className="row">
                                            <div className="col-md-12 mb-3">
                                                <div className="row">
                                                    <div className="col-md-6 mb-3">
                                                        <label htmlFor="lib" className="mb-1">Profile name</label>
                                                        <div className="input-group flex-nowrap">
                                                            <span className="input-group-text" id="lib">
                                                                <TextParagraph />
                                                            </span>
                                                            <input type="text" 
                                                                className="form-control" 
                                                                placeholder=""
                                                                value={lib}
                                                                onChange={(e) => setLib(e.target.value)}
                                                                disabled={editedstate ? false : true}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <label htmlFor="ident" className="mb-1">Identity</label>
                                                        <div className="input-group flex-nowrap">
                                                            <span className="input-group-text" id="ident">
                                                                <TextLeft />
                                                            </span>
                                                            <input type="text" 
                                                                className="form-control" 
                                                                placeholder=""
                                                                value={ident}
                                                                onChange={(e) => setIdent(e.target.value)}
                                                                disabled={editedstate ? false : true}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <label className="mb-1" htmlFor="space">Workspace</label>
                                                        <Select
                                                            id="space"
                                                            name="space"
                                                            options={spaces}
                                                            value={space}
                                                            onChange={(selected) => { setSpace(selected); }}
                                                            isDisabled={editedstate ? false : true}
                                                        />
                                                    </div>
                                                    <div className="col-md-6 mb-3">
                                                        <label htmlFor="etat" className="mb-1">Profile state</label>
                                                        <div className="input-group flex-nowrap">
                                                            <span className={`input-group-text ${
                                                                    etat === 1 ? "bg-warning" :
                                                                    etat ===2 ? "bg-success" :
                                                                    ""
                                                                }`
                                                            } 
                                                                id="etat"
                                                            >
                                                                <Asterisk />
                                                            </span>
                                                            <input
                                                                readOnly
                                                                type="text" 
                                                                className={`form-control ${
                                                                        etat === 1 ? "text-white bg-warning" :
                                                                        etat ===2 ? "text-white bg-success" :
                                                                        ""
                                                                    } 
                                                                `} 
                                                                id="etat"
                                                                value={
                                                                    etat === 1 ? "Profile not used" :
                                                                    etat ===2 ? "Profile used" :
                                                                    ""
                                                                }
                                                                placeholder=""
                                                                onChange={(e) => setEtat(e.target.value)}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 mb-3">
                                                        <label htmlFor="desc" className="mb-1">Profile description</label>
                                                        <div className="input-group flex-nowrap">
                                                            <span className="input-group-text" id="desc">
                                                                <TextParagraph />
                                                            </span>
                                                            <textarea 
                                                                className="form-control" 
                                                                placeholder="No description"
                                                                value={desc}
                                                                style={{height: 154}}
                                                                onChange={(e) => setDesc(e.target.value)}
                                                                disabled={editedstate ? false : true}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 mb-3">
                                                        <label htmlFor="datecrea" className="mb-1">Added date</label>
                                                        <div className="input-group flex-nowrap">
                                                            <span className="input-group-text" id="datecrea">
                                                                <Calendar />
                                                            </span>
                                                            <input type={editedstate ? "date" : "text"} 
                                                                className="form-control" 
                                                                placeholder=""
                                                                value={datecrea}
                                                                onChange={(e) => setDatecrea(e.target.value)}
                                                                disabled
                                                            />
                                                        </div>
                                                    </div>
                                                    {/* <div className="col-md-6 mb-3">
                                                        <label htmlFor="dateupda" className="mb-1">Date de dernière mise à jour</label>
                                                        <div className="input-group flex-nowrap">
                                                            <span className="input-group-text" id="dateupda">
                                                                <Calendar />
                                                            </span>
                                                            <input type={editedstate ? "date" : "text"} 
                                                                className="form-control" 
                                                                placeholder=""
                                                                value={dateupda}
                                                                onChange={(e) => setDateupda(e.target.value)}
                                                                disabled
                                                            />
                                                        </div>
                                                    </div> */}
                                                    
                                                </div>
                                            </div>
                                            {editedstate && <div className="col-md-12 mt-2">
                                                <button type="submit" 
                                                    title="Update profile informations" 
                                                    className="btn-shadow ml-3 btn btn-primary btn-sm float-right"
                                                    // disabled={names && statusinput["value"] ? false : true}
                                                >
                                                    <i className="fa fa-check mr-2"></i> 
                                                    <span>Update profile</span> {fetching && <Spinner
                                                            as="span"
                                                            animation="border"
                                                            size="sm"
                                                            role="status"
                                                            aria-hidden="true"
                                                    />}
                                                </button>
                                                <button onClick={() => setEditedstate(false)} 
                                                    title="Cancel operation"
                                                    className="btn-shadow ml-3 btn btn-danger btn-sm float-right">
                                                    <i className="fa fa-reply mr-1"></i> <span>Cancel</span>
                                                </button>
                                            </div>}
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ToastContainer />
                </div>
            </div>}
        </>
    )
}